import React, {useMemo} from "react";
import router, {Route} from "@/routing/Router";
import AdminLayout from "@widgets/layout/AdminLayout";
import LocationOverview from "@widgets/location/LocationOverview";

const Location = () => {
    const route: Route = useMemo(() => router.location, []);

    return (
        <AdminLayout currentPage={route}>
            <LocationOverview/>
        </AdminLayout>
    );
};

export default Location;